
































import { Component, Vue } from "vue-property-decorator";
import { FormBuilderConfig } from "./types/FormBuilderTypes";
import { FormItem } from "@/components/DinamicallyForm/FormItem";
import { ComponentsTypes } from "@/components/DinamicallyForm/TipoComponentes";
import DinamicallyForm from "@/components/DinamicallyForm/DinamicallyForm.vue";

@Component({
  components: {
    DinamicallyForm,
  },
})
export default class FormBuilderPreview extends Vue {
  public formConfig: FormBuilderConfig | null = null;
  public formFields: FormItem[] = [];

  public created() {
    // Load form config from sessionStorage
    const previewData = sessionStorage.getItem("formBuilder_preview");
    if (previewData) {
      this.formConfig = JSON.parse(previewData);
      this.generateFormItems();
    } else {
      alert("No hay datos de preview disponibles");
      this.closePreview();
    }
  }

  public get tabNames(): string[] {
    if (!this.formConfig) return [];
    return this.formConfig.tabs.map((t) => t.tabName);
  }

  public generateFormItems() {
    if (!this.formConfig) return;

    this.formFields = this.formConfig.fields.map((field) => {
      const formItem = new FormItem(
        field.defaultValue || "",
        field.caption,
        field.variableName,
        field.datatype,
        field.visible,
        field.maxLength,
        field.intab
      );

      // Apply basic properties
      if (field.required) formItem.isRequired(true);
      if (field.readonly) formItem.isReadOnly(true);
      if (field.mayuscula) formItem.isMayuscula(true);
      if (field.icon) formItem.CrearIcono(field.icon);
      if (field.validacion) formItem.SetValidacion(field.validacion);

      // Apply dimensions
      formItem.Dimesiones(field.dim_cols, field.dim_sm, field.dim_md);

      // Apply component-specific configurations
      switch (field.componentType) {
        case ComponentsTypes.Date:
          formItem.CreateDate();
          if (field.minDate) {
            formItem.minDate = field.minDate;
          }
          break;

        case ComponentsTypes.DateTime:
          formItem.CreateDateTime();
          break;

        case ComponentsTypes.TextArea:
          formItem.CreateTextArea();
          break;

        case ComponentsTypes.Switch:
          formItem.CreateSwitch(
            field.switchOn || "Sí",
            field.switchOff || "No"
          );
          break;

        case ComponentsTypes.SingleCombo:
          if (field.comboConfig) {
            formItem.CreateComboSingle(
              field.comboConfig.dataSource || [],
              field.comboConfig.displayExpr,
              field.comboConfig.valueExpr
            );
          }
          break;

        case ComponentsTypes.MultiCombo:
          if (field.comboConfig) {
            formItem.CreateComboMultiple(
              field.comboConfig.dataSource || [],
              field.comboConfig.displayExpr,
              field.comboConfig.valueExpr
            );
          }
          break;

        case ComponentsTypes.RadioButton:
          if (field.radioOptions) {
            formItem.CreateRadioButton(
              field.radioOptions.map((opt) => ({
                DisplayExpr: opt.label,
                ValueExpr: opt.value,
              }))
            );
          }
          break;
      }

      return formItem;
    });
  }

  public closePreview() {
    window.close();
  }
}
